export const TEST_ENV = 'test';
export const PRODUCTION_ENV = 'production';
export const STAGING_ENV = 'staging';
export const DEVELOPMENT_ENV = 'development';

const getEnvironment = () => {
  // "development" for `react-scripts start`
  // "production" for `react-scripts build`
  // "test" for `react-scripts test`
  const env = process.env.NODE_ENV;
  if (env === DEVELOPMENT_ENV && window.location.href.indexOf('branch=local') >= 0) {
    // branch-local: when on production, but using the url param to get locally hosted assets
    return 'branch-local';
  }
  return env;
};

export const getSpecificEnvironment = () => {
  const vagueEnv = getEnvironment();

  // Adding this because cypress normally returns 'development'
  // which doesn't make too much sense
  if (window.Cypress) return TEST_ENV;
  if (vagueEnv !== PRODUCTION_ENV) return vagueEnv;
  if (/(.+\\.)?pagerduty\.com$/.test(window.location.hostname)) return PRODUCTION_ENV;
  return STAGING_ENV;
};

export const isTestOrDev = () => getSpecificEnvironment() === TEST_ENV
  || getSpecificEnvironment() === DEVELOPMENT_ENV;
export const isIntegratedDevMode = () => window.location.origin.includes('pagerduty.net');
export const isTestEnvironment = () => getSpecificEnvironment() === TEST_ENV;
export const isProductionEnvironment = getSpecificEnvironment() === PRODUCTION_ENV;

export default getEnvironment;
